export const fullForgerockResponseRegisterStep = {
  authId: 'toto',
  stage: 'Registration Page',
  callbacks: [
    {
      type: 'TextOutputCallback',
      output: [
        {
          name: 'message',
          value: 'mock-json@yopmail.com',
        },
        {
          name: 'messageType',
          value: '0',
        },
      ],
      _id: 2,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'custom_section_profile',
        },
        {
          name: 'prompt',
          value: 'Mon profil',
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: {},
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken2',
          value: '',
        },
        {
          name: 'IDToken2validateOnly',
          value: false,
        },
      ],
      _id: 3,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'custom_professional',
        },
        {
          name: 'prompt',
          value: 'Professionnel',
        },
        {
          name: 'required',
          value: true,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['VALID_TYPE'],
            fallbackPolicies: null,
            name: 'custom_professional',
            policies: [
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken3',
          value: '',
        },
        {
          name: 'IDToken3validateOnly',
          value: false,
        },
      ],
      _id: 4,
    },
    {
      type: 'ValidatedCreatePasswordCallback',
      output: [
        {
          name: 'echoOn',
          value: false,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['VALID_TYPE'],
            fallbackPolicies: null,
            name: 'password',
            policies: [
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'prompt',
          value: 'Mot de passe',
        },
      ],
      input: [
        {
          name: 'IDToken4',
          value: '',
        },
        {
          name: 'IDToken4validateOnly',
          value: false,
        },
      ],
      _id: 5,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'custom_section_contact',
        },
        {
          name: 'prompt',
          value: 'Mes coordonnées',
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: {},
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken5',
          value: '',
        },
        {
          name: 'IDToken5validateOnly',
          value: false,
        },
      ],
      _id: 6,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'custom_gender',
        },
        {
          name: 'prompt',
          value: 'Genre',
        },
        {
          name: 'required',
          value: true,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['VALID_TYPE'],
            fallbackPolicies: null,
            name: 'custom_gender',
            policies: [
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken6',
          value: '',
        },
        {
          name: 'IDToken6validateOnly',
          value: false,
        },
      ],
      _id: 7,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'sn',
        },
        {
          name: 'prompt',
          value: 'Nom',
        },
        {
          name: 'required',
          value: true,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['REQUIRED', 'MATCH_REGEXP', 'VALID_TYPE'],
            fallbackPolicies: null,
            name: 'sn',
            policies: [
              {
                policyRequirements: ['REQUIRED'],
                policyId: 'required',
              },
              {
                policyRequirements: ['MATCH_REGEXP'],
                policyId: 'regexpMatches',
                params: {
                  regexp: "[0-9a-zA-Z\\sáàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ'\\-]{1,255}",
                },
              },
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken7',
          value: '',
        },
        {
          name: 'IDToken7validateOnly',
          value: false,
        },
      ],
      _id: 8,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'givenName',
        },
        {
          name: 'prompt',
          value: 'Prénom',
        },
        {
          name: 'required',
          value: true,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['REQUIRED', 'MATCH_REGEXP', 'VALID_TYPE'],
            fallbackPolicies: null,
            name: 'givenName',
            policies: [
              {
                policyRequirements: ['REQUIRED'],
                policyId: 'required',
              },
              {
                policyRequirements: ['MATCH_REGEXP'],
                policyId: 'regexpMatches',
                params: {
                  regexp: "[0-9a-zA-Z\\sáàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ'\\-]{1,255}",
                },
              },
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken8',
          value: '',
        },
        {
          name: 'IDToken8validateOnly',
          value: false,
        },
      ],
      _id: 9,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'custom_birthday',
        },
        {
          name: 'prompt',
          value: 'Date de naissance',
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['VALID_TYPE'],
            fallbackPolicies: null,
            name: 'custom_birthday',
            policies: [
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken9',
          value: '',
        },
        {
          name: 'IDToken9validateOnly',
          value: false,
        },
      ],
      _id: 10,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'telephoneNumber',
        },
        {
          name: 'prompt',
          value: 'Numéro de téléphone',
        },
        {
          name: 'required',
          value: true,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['MATCH_REGEXP', 'VALID_TYPE'],
            fallbackPolicies: null,
            name: 'telephoneNumber',
            policies: [
              {
                policyRequirements: ['MATCH_REGEXP'],
                policyId: 'regexpMatches',
                params: {
                  regexp: '^0[1-79]\\s?\\d{2}\\s?\\d{2}\\s?\\d{2}\\s?\\d{2}$',
                },
              },
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken10',
          value: '',
        },
        {
          name: 'IDToken10validateOnly',
          value: false,
        },
      ],
      _id: 11,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'custom_section_address',
        },
        {
          name: 'prompt',
          value: 'Mon adresse',
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: {},
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken11',
          value: '',
        },
        {
          name: 'IDToken11validateOnly',
          value: false,
        },
      ],
      _id: 12,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'postalCode',
        },
        {
          name: 'prompt',
          value: 'Code postal',
        },
        {
          name: 'required',
          value: true,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['MATCH_REGEXP', 'VALID_TYPE'],
            fallbackPolicies: null,
            name: 'postalCode',
            policies: [
              {
                policyRequirements: ['MATCH_REGEXP'],
                policyId: 'regexpMatches',
                params: {
                  regexp: '^(?:0[1-9]|[1-8]\\d|9[0-8])\\d{3}$',
                },
              },
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken18',
          value: '',
        },
        {
          name: 'IDToken18validateOnly',
          value: false,
        },
      ],
      _id: 19,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'city',
        },
        {
          name: 'prompt',
          value: 'Ville',
        },
        {
          name: 'required',
          value: true,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['MATCH_REGEXP', 'VALID_TYPE'],
            fallbackPolicies: null,
            name: 'city',
            policies: [
              {
                policyRequirements: ['MATCH_REGEXP'],
                policyId: 'regexpMatches',
                params: {
                  regexp: "^[a-zA-Z0-9áàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ'\\s\\-]{1,30}$",
                },
              },
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken19',
          value: '',
        },
        {
          name: 'IDToken19validateOnly',
          value: false,
        },
      ],
      _id: 20,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'postalAddress',
        },
        {
          name: 'prompt',
          value: 'Adresse',
        },
        {
          name: 'required',
          value: true,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['MATCH_REGEXP', 'VALID_TYPE'],
            fallbackPolicies: null,
            name: 'postalAddress',
            policies: [
              {
                policyRequirements: ['MATCH_REGEXP'],
                policyId: 'regexpMatches',
                params: {
                  regexp: "^[a-zA-Z0-9áàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ'\\s\\-]{1,30}$",
                },
              },
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken12',
          value: '',
        },
        {
          name: 'IDToken12validateOnly',
          value: false,
        },
      ],
      _id: 13,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'custom_address2',
        },
        {
          name: 'prompt',
          value: "Complément d'adresse",
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['MATCH_REGEXP', 'VALID_TYPE'],
            fallbackPolicies: null,
            name: 'custom_address2',
            policies: [
              {
                policyRequirements: ['MATCH_REGEXP'],
                policyId: 'regexpMatches',
                params: {
                  regexp: "^[a-zA-Z0-9áàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ'\\s\\-]{1,30}$",
                },
              },
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken13',
          value: '',
        },
        {
          name: 'IDToken13validateOnly',
          value: false,
        },
      ],
      _id: 14,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'custom_darty_building',
        },
        {
          name: 'prompt',
          value: 'Bâtiment',
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['MATCH_REGEXP', 'VALID_TYPE'],
            fallbackPolicies: null,
            name: 'custom_darty_building',
            policies: [
              {
                policyRequirements: ['MATCH_REGEXP'],
                policyId: 'regexpMatches',
                params: {
                  regexp: '^[a-zA-Z0-9]{0,3}$',
                },
              },
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken14',
          value: '',
        },
        {
          name: 'IDToken14validateOnly',
          value: false,
        },
      ],
      _id: 15,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'custom_darty_stairs',
        },
        {
          name: 'prompt',
          value: 'Escalier',
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['MATCH_REGEXP', 'VALID_TYPE'],
            fallbackPolicies: null,
            name: 'custom_darty_stairs',
            policies: [
              {
                policyRequirements: ['MATCH_REGEXP'],
                policyId: 'regexpMatches',
                params: {
                  regexp: '^[a-zA-Z0-9]{0,3}$',
                },
              },
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken15',
          value: '',
        },
        {
          name: 'IDToken15validateOnly',
          value: false,
        },
      ],
      _id: 16,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'custom_darty_floor',
        },
        {
          name: 'prompt',
          value: 'Etage',
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['MATCH_REGEXP', 'VALID_TYPE'],
            fallbackPolicies: null,
            name: 'custom_darty_floor',
            policies: [
              {
                policyRequirements: ['MATCH_REGEXP'],
                policyId: 'regexpMatches',
                params: {
                  regexp: '^[a-zA-Z0-9]{0,3}$',
                },
              },
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken16',
          value: '',
        },
        {
          name: 'IDToken16validateOnly',
          value: false,
        },
      ],
      _id: 17,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'custom_darty_door',
        },
        {
          name: 'prompt',
          value: 'Porte',
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['MATCH_REGEXP', 'VALID_TYPE'],
            fallbackPolicies: null,
            name: 'custom_darty_door',
            policies: [
              {
                policyRequirements: ['MATCH_REGEXP'],
                policyId: 'regexpMatches',
                params: {
                  regexp: '^[a-zA-Z0-9]{0,3}$',
                },
              },
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken17',
          value: '',
        },
        {
          name: 'IDToken17validateOnly',
          value: false,
        },
      ],
      _id: 18,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'country',
        },
        {
          name: 'prompt',
          value: 'Pays',
        },
        {
          name: 'required',
          value: true,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['REQUIRED', 'NOT_NULL', 'VALID_TYPE'],
            fallbackPolicies: null,
            name: 'country',
            policies: [
              {
                policyRequirements: ['REQUIRED'],
                policyId: 'required',
              },
              {
                policyRequirements: ['NOT_NULL'],
                policyId: 'not-null',
              },
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken20',
          value: '',
        },
        {
          name: 'IDToken20validateOnly',
          value: false,
        },
      ],
      _id: 21,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'custom_section_consents',
        },
        {
          name: 'prompt',
          value: 'Mes préférences de contact',
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: {},
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken21',
          value: '',
        },
        {
          name: 'IDToken21validateOnly',
          value: false,
        },
      ],
      _id: 22,
    },
    {
      type: 'BooleanAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'd_grp_email_sms_in',
        },
        {
          name: 'prompt',
          value: 'J’accepte d’être informé(e) par email et sms des offres personnalisées de la part de DARTY.',
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: [],
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: false,
        },
      ],
      input: [
        {
          name: 'IDToken22',
          value: false,
        },
        {
          name: 'IDToken22validateOnly',
          value: false,
        },
      ],
      _id: 23,
    },
    {
      type: 'BooleanAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'd_grp_part_email_sms_in',
        },
        {
          name: 'prompt',
          value: 'Je souhaite recevoir par email et sms des offres personnalisées du Groupe Fnac Darty et de ses partenaires.',
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: [],
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: false,
        },
      ],
      input: [
        {
          name: 'IDToken23',
          value: false,
        },
        {
          name: 'IDToken23validateOnly',
          value: false,
        },
      ],
      _id: 24,
    },
    {
      type: 'BooleanAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'd_grp_d_part_phone_out',
        },
        {
          name: 'prompt',
          value: 'Je souhaite être contacté par Darty et ses partenaires pour des offres par téléphone.',
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: [],
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: true,
        },
      ],
      input: [
        {
          name: 'IDToken24',
          value: true,
        },
        {
          name: 'IDToken24validateOnly',
          value: false,
        },
      ],
      _id: 25,
    },
    {
      type: 'BooleanAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'd_grp_d_fd_part_exploit_out',
        },
        {
          name: 'prompt',
          value:
            'J’accepte que mon profil client soit utilisé pour profiter des offres personnalisées du Groupe Fnac Darty et de ses partenaires V4.\n',
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: [],
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: true,
        },
      ],
      input: [
        {
          name: 'IDToken25',
          value: true,
        },
        {
          name: 'IDToken25validateOnly',
          value: false,
        },
      ],
      _id: 26,
    },
  ],
};
